query allTennisPlayers(
  $first: Int,
  $offset: Int,
  $filter: TennisPlayerFilter,
  $condition: TennisPlayerCondition
  ) {
  players: allTennisPlayers(
      first: $first,
      offset: $offset,
      filter: $filter,
      condition: $condition
    ) {
    nodes {
      playerMappings: tennisPlayerMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
          playerIndex
          playerTeamMapping: playerTeamMappingsByFeedAndPlayerExtId {
            nodes {
              discriminator
              team: tennisTeamMapping { 
                extRef
              }
            }
          }
        }
      }
      name
      source
      playerId
      playerIndex
    }
    totalCount
  }
}
